const BASE_URL = "https://www.sanity.io/docs/help/";
function generateHelpUrl(slug) {
  return BASE_URL + slug;
}
export { generateHelpUrl };
//# sourceMappingURL=generate-help-url.esm.js.map
